import React, { useEffect, useState } from 'react'
import { NmpFormStyle as S } from 'src/pages/NmpJoinFormPage/styled'
import RenderIf from 'src/components/RenderIf'
import { useFormContext } from 'react-hook-form'
import { AllTermsBooleanType, JoinFormType } from 'src/types/react-hook-form'
import { DefaultJoinFormPageProps } from 'src/pages/DefaultJoinFormPage/index'
import img_banner from 'src/assets/images/nmp/img_banner.png'
import btn_enable from 'src/assets/images/nmp/btn_enable.png'
import btn_hover from 'src/assets/images/nmp/btn_hover.png'
import btn_pressed from 'src/assets/images/nmp/btn_pressed.png'
import img_kt from 'src/assets/images/nmp/img_kt.png'
import img_lgu from 'src/assets/images/nmp/img_lgu.png'
import img_skt from 'src/assets/images/nmp/img_skt.png'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import { useSearchParams } from 'react-router-dom'
import handleAutoInputGuard from 'src/service/utils/handleAutoInputGuard'

const AGENCY_LIST = [
  { id: 0, img: img_skt, name: '통신사skt' },
  { id: 1, img: img_kt, name: '통신사kt' },
  { id: 2, img: img_lgu, name: '통신사lgu+' },
]

const NmpJoinFormPageView = (props: DefaultJoinFormPageProps) => {
  const {
    registerAttributeExcludeAllTerms: termsData,
    registerAttribute,
    otpCertRequest,
    otpCertVerify,
    count,
  } = props

  const { handleSubmit, getValues, register } = useFormContext<JoinFormType>()

  const { pCode, requestIdPath, telecom } = useParamsList()
  const [searchParams] = useSearchParams()
  const search_params = `?${searchParams.toString()}`

  const handleSubmitOtpCertRequest = handleSubmit(otpCertRequest.submit, otpCertRequest.error)
  const handleSubmitOtpVerify = handleSubmit(otpCertVerify.submit, otpCertVerify.error)

  const [depth, setDepth] = useState(1)
  const [goFormBtn, setGoFormBtn] = useState(0) // 0: enable, 1: hover, 2: press
  const goFormBtnImg = goFormBtn === 0 ? btn_enable : goFormBtn === 1 ? btn_hover : btn_pressed
  const isTranId = !!getValues('TranID') && getValues('TranID') !== ''

  useEffect(() => {
    depth === 2 &&
      setTimeout(() => {
        setDepth(3)
      }, 2000)
  }, [depth])

  return (
    <S.NmpFormContainer>
      <S.PreloadImages />
      {/*헤더*/}
      <S.HeaderContainer>
        <S.HeaderText>
          휴대폰쿠폰지갑 <S.HeaderTextHighlight>이동통신사유료부가서비스</S.HeaderTextHighlight>
        </S.HeaderText>
      </S.HeaderContainer>
      {/*내용*/}
      <S.BodyContainer $depth={depth}>
        <S.ContentsContainer $depth={depth}>
          {/*Depth1-2*/}
          <RenderIf when={depth !== 3}>
            <S.MoveToFormBtn
              onMouseEnter={() => setGoFormBtn(1)}
              onMouseUp={() => setGoFormBtn(1)}
              onMouseDown={() => setGoFormBtn(2)}
              onMouseLeave={() => setGoFormBtn(0)}
              onClick={() => depth === 1 && setDepth(2)}
            >
              <S.MoveToFormBtnImg
                src={goFormBtnImg}
                alt={'go_to_form_btn'}
                $isActive={depth === 1}
              />
            </S.MoveToFormBtn>
          </RenderIf>
          {/*Depth3*/}
          <RenderIf when={depth === 3}>
            <S.MainContentsContainer>
              {/*배너*/}
              <S.BannerImg src={img_banner} alt={'배너 이미지'} />
              {/*가입폼*/}
              <S.CertFormContainer onSubmit={(e) => e.preventDefault()}>
                {/*통신사 선택*/}
                <S.AgencyContainer>
                  <S.label>이동통신사</S.label>
                  <S.AgencyTabs>
                    {AGENCY_LIST.map((el) => (
                      <S.AgencyItem
                        to={`/nmp/${pCode}/${requestIdPath}/${el.id}${search_params}`}
                        $isActive={el.id === Number(telecom)}
                        $disabled={isTranId}
                        $agency={el.id}
                        key={el.id}
                        onClick={(e) => isTranId && e.preventDefault()}
                      >
                        <S.AgencyImg src={el.img} alt={el.name} />
                      </S.AgencyItem>
                    ))}
                  </S.AgencyTabs>
                </S.AgencyContainer>
                {/*휴대폰번호 Input*/}
                <S.PnumberContainer>
                  <S.label>휴대폰번호</S.label>
                  <S.Input
                    {...register('PNumber', registerAttribute.PNumber.register_options)}
                    placeholder={'휴대폰번호 -를 제외하고 입력'}
                    disabled={isTranId}
                    autoComplete={'off'}
                    inputMode={'numeric'}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmitOtpCertRequest()}
                  />
                </S.PnumberContainer>
                {/*인증번호 발송*/}
                <S.NoneLabelContainer>
                  {!isTranId ? (
                    <S.CertBtn onClick={handleSubmitOtpCertRequest}>인증번호 발송</S.CertBtn>
                  ) : (
                    <S.CertInputContainer>
                      {/*인증번호 Input*/}
                      <S.Input
                        {...register(
                          'ApprovalNumber',
                          registerAttribute.ApprovalNumber.register_options,
                        )}
                        placeholder={'인증번호 입력'}
                        autoComplete={'one-time-code'}
                        inputMode={'numeric'}
                        onKeyDown={(e) => handleAutoInputGuard(e, handleSubmitOtpVerify)}
                      />
                      <S.ResendContainer>
                        {/*타이머*/}
                        <S.Timer>{count?.substring(4, 12)}</S.Timer>
                        {/*재전송 버튼*/}
                        <S.ResendBtn onClick={handleSubmitOtpCertRequest}>재발송</S.ResendBtn>
                      </S.ResendContainer>
                    </S.CertInputContainer>
                  )}
                </S.NoneLabelContainer>

                <S.NoneLabelContainer>
                  <S.TermsContainer>
                    <S.TotalTermContainer>
                      <S.TermLabel mode={'all'}>
                        <S.TermCheckbox
                          mode={'all'}
                          {...register('allTerms', registerAttribute.allTerms?.register_options)}
                          onClick={registerAttribute.allTerms?.register_options?.onClick}
                        />
                        필수약관 모두 동의
                      </S.TermLabel>
                    </S.TotalTermContainer>
                    <S.TermItemsContainer>
                      {termsData?.map((termsItems) => {
                        const { tag, termsTitle, register_options, showTermsPopup } = termsItems
                        const isNoRequired = termsTitle?.includes('선택')
                        const title = termsTitle?.replace(/\(선택\) |\(필수\) /g, '')

                        return (
                          <S.EachTermContainer key={tag}>
                            <S.TermCheckbox
                              mode={'each'}
                              {...register(tag as keyof AllTermsBooleanType, register_options)}
                            />
                            <S.TermLabel mode={'each'} onClick={showTermsPopup}>
                              {title}
                              {isNoRequired && <S.NoRequiredText>(선택)</S.NoRequiredText>}
                            </S.TermLabel>
                          </S.EachTermContainer>
                        )
                      })}
                    </S.TermItemsContainer>
                  </S.TermsContainer>
                </S.NoneLabelContainer>
                {/*가입 Button*/}
                <S.NoneLabelContainer>
                  <S.JoinSubmitBtn onClick={handleSubmitOtpVerify}>
                    휴대폰쿠폰지갑 유료부가서비스가입
                  </S.JoinSubmitBtn>
                </S.NoneLabelContainer>
                {/*주의사항*/}
                <S.NoneLabelContainer>
                  <S.WarningText>
                    매월 부가세포함 5,500원 본 서비스는 SKT, KT, LGU+ 통신요금에 포함되어 매월
                    부과됩니다.
                  </S.WarningText>
                </S.NoneLabelContainer>
              </S.CertFormContainer>
            </S.MainContentsContainer>
          </RenderIf>
          {/*푸터*/}
          <S.FooterContainer>
            <S.FooterText>
              · 본 서비스는 ㈜데이터유니버스가 운영합니다. 고객센터 1855-4531(이용, 해지문의) · 본
              서비스는 청약철회가 불가능한 상품입니다.
              <br />
              · 서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다. · 본
              이벤트의 경품으로 지급된 쿠폰을 기한 내에 미등록하여 이용기한이 만료된 경우 보상하지
              않습니다. · 본 이벤트의 경품은 휴대폰 번호로 문자 발송되며 운영사의 사정에 따라 지연될
              수 있습니다.
              <br />· 본 이벤트에 비정상적, 불법적인 방법으로 참여한 경우, 당첨자 선정에서
              제외되거나 당첨이 취소될 수 있습니다. · 본 이벤트는 운영사의 사정에 따라 별도 고지없이
              변경 또는 중단될 수 있습니다.본 이벤트는 휴대폰번호 기준 1회만 참여 가능합니다.
              <br />· 휴대폰도난결제 보상 보험은 가입 다음날 0시부터 제공되며, 자기부담금 20만원(1회
              사고당)이 발생합니다. 해당 보험은 1인 1사고당 보험한도액 100만원 내 보상하며, 증권상
              최대 보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.
              <br />· 본 서비스는 PC 및 모바일 브라우저에서 웹사이트에 접속하여 서비스 이용이
              가능하므로 대부분의 휴대폰 OS 및 단말기 제약이 없습니다.
              <br />· 서비스 내 한정 수량으로 판매되는 핫딜 쿠폰은 회차당 1인 1개, 월 최대 10개까지
              구매 가능하며, 판매 정책은 추후 변경될 수 있습니다.
              <br />· 홈페이지 주소 : https://www.couponwallet.co.kr/ · 전화번호 : 1855-4531, 이메일
              : cs_coupon@datau.co.kr · (주)데이터유니버스 서울 영등포구 여의대로 70
              <br />· 사업자등록번호 : 382-86-01230 / 통신판매업신고 : 제2020-서울영등포-1315호
            </S.FooterText>
          </S.FooterContainer>
        </S.ContentsContainer>
      </S.BodyContainer>
    </S.NmpFormContainer>
  )
}
export default NmpJoinFormPageView
